export default Vue.extend({
  template: `
    <div class='search-list'>
      <div class='option justify-box'
           v-for='item in items'
           :key='item.id'
           v-if='items.length'
           @click='toggle(item)'>
        <slot name='option-template' :item='item'></slot>
      </div>
      <div class="option" v-if='!items.length'>
       <div class="placeholder">没有搜索结果</div>
      </div>
    </div>
  `,

  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    toggleFunc: {
      type: Function,
    },
  },

  data() {
    return {
      selectedItems: [],
    };
  },

  methods: {
    toggle(item) {
      if (this.toggleFunc != null) {
        this.toggleFunc(item);
      } else {
        item._selected = !item._selected;
        this.$emit('valueChanged', item);
      }
    },

    unselect(item) {
      if (item._selected) this.toggle(item);
    },
  },
});
